<p-card header="Supplies Inventory">
  <p-table [value]="supplyInventoryItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="isChepComponents">Repair Type<span class="required">*</span></th>
        <th>Product<span class="required">*</span></th>
        <th>Pieces<span class="required">*</span></th>
        <th *ngIf="isChepComponents">Allocated <br> From PLUS<span class="required">*</span></th>
        <th>Delete</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
      <tr [formGroup]="rowData">
        <td *ngIf="isChepComponents">
          <p-dropdown
            [options]="bayTypesSelect"
            formControlName="bayType"
            appendTo="body"
            name="product"
            [required]
            [editable]="false">
          </p-dropdown>
        </td>
        <td>
          <p-dropdown
            [options]="productSelect"
            formControlName="productId"
            appendTo="body"
            name="productId"
            [required]
            [filter]="true"
            [editable]="false"
            [resetFilterOnHide]="true">
          </p-dropdown>
        </td>
        <td class="p-inputgroup inline">
          <input pInputText type="number"
            class="pieces"
            formControlName="pieces1"
            name="pieces1"
            required
            lib-numeric>
          <span class="p-inputgroup-addon">{{getVolumeUOM(rowData.controls.productId.value)}}</span>
        </td>
        <td *ngIf="isChepComponents">
          <input pInputText type="number"
            formControlName="allocatedFromPlus"
            style="width:100%"
            name="allocatedFromPlus"
            required
            lib-numeric>
        </td>
        <td>
          <confirmation-button
            [iconsOnly]="true"
            actionIcon="pi pi-times"
            actionText="Delete"
            confirmIcon="pi pi-times"
            confirmText="Delete"
            cancelIcon="pi pi-minus-circle"
            cancelText="Cancel"
            [disabled]="rowData.disabled"
            (actionConfirmed)="deleteRow(rowData)">
          </confirmation-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="isChepComponents ? 5 : 3" class="centered">
          No data available
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr [formGroup]="addForm">
        <td *ngIf="isChepComponents">
          <p-dropdown [options]="bayTypesSelect" [required] placeholder="-- Select --" inputId="bayType" class="form-control"
              name="bayType" [editable]="false" formControlName="bayType" appendTo="body" (onChange)="onRepairTypeChange()">
          </p-dropdown>
          <error-block [field]="addForm.controls.bayType" [messages]="{
            required: 'Repair Type is required.'
          }"></error-block>
        </td>
        <td>
          <p-dropdown [options]="productSelect" [required] placeholder="-- Select Product --" inputId="productID" appendTo="body" (onChange)="onProductChange()"
              class="form-control" name="productId" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="productId">
          </p-dropdown>
          <error-block [field]="addForm.controls.productId" [messages]="{
              required: 'Product is required.'
            }">
            </error-block>
        </td>
        <td>
          <div class="p-inputgroup inline">
            <input type="number" lib-numeric pInputText id="pieces1" required name="pieces1" class="form-control pieces" formControlName="pieces1"/>
            <span class="p-inputgroup-addon">{{volumeUOM}}</span>
          </div>
            <error-block [field]="addForm.controls.pieces1" [messages]="{
                required: 'Pieces is required.'
              }">
            </error-block>
        </td>
        <td *ngIf="isChepComponents">
          <input type="number" lib-numeric pInputText id="allocatedFromPlus" required name="allocatedFromPlus" class="form-control" formControlName="allocatedFromPlus" />
          <error-block [field]="addForm.controls.allocatedFromPlus" [messages]="{
            required: 'Allocated From Plus is required.'
          }">
          </error-block>
        </td>
        <td>
            <button type="button" pButton
              icon="pi pi-plus"
              iconPos="left"
              (click)="saveSI();"
              label="Add"
              [disabled]="addForm.disabled"
              [ngClass]="{ 'p-state-disabled': !addForm.valid }"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
